/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import {
  Avatar,
  Icon,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  withStyles,
} from '@material-ui/core';
import { Validate } from '../../../other';
import { ToggleUI, ButtonUI } from '../../common';
import {
  suscription_amplitude_events,
  createAmplitudeEventWithDevice,
} from '../../amplitude';

const handleClickDescargarFactura = (e) => {
  e.stopPropagation();
  createAmplitudeEventWithDevice(
    suscription_amplitude_events.plan_descargar_factura.event_name
  );
};

const renderizarFacturas = (
  facturas,
  pago_manual,
  modalHandler,
  classes,
  idCountry = 'ARG'
) => {
  if (facturas.length > 0) {
    return facturas.map((factura, index) => {
      return (
        <ListItem divider={index < facturas.length - 1} key={factura.id}>
          <ListItemAvatar>
            <Avatar>
              <Icon>receipt</Icon>
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={'Vencimiento ' + factura.fecha_vencimiento}
            classes={{ root: classes.list_text }}
            secondary={
              <span className={classes.span}>
                <span className={classes.span}>
                  Monto: ${Validate.number_format(factura.monto, idCountry)}
                </span>
                <span className={classes.span}>
                  Abonado: {factura.paga ? 'Si' : 'No'}
                </span>
                <ToggleUI show={factura.facturada}>
                  <ToggleUI show={factura.pdf ? true : false}>
                    <span className={classes.span_aux}>
                      <a
                        onClick={handleClickDescargarFactura}
                        href={factura.pdf}
                        className={classes.link}
                        target="_blank"
                      >
                        DESCARGAR FACTURA
                      </a>
                    </span>
                  </ToggleUI>
                  <ToggleUI show={factura.pdf ? false : true}>
                    <span className={classes.span_aux}>
                      <a
                        onClick={handleClickDescargarFactura}
                        href={
                          'https://api.empretienda.com/tienda/comprobante/' +
                          factura.id
                        }
                        className={classes.link}
                        target="_blank"
                      >
                        DESCARGAR FACTURA
                      </a>
                    </span>
                  </ToggleUI>
                </ToggleUI>
                <ToggleUI show={!factura.paga && pago_manual}>
                  <span className={classes.span_aux}>
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        modalHandler(true, 'informar_pago', factura);
                      }}
                      className={classes.link}
                    >
                      INFORMAR PAGO
                    </a>
                  </span>
                </ToggleUI>
              </span>
            }
          />
          <ToggleUI show={factura.paga === 0 && pago_manual === 1}>
            <ListItemSecondaryAction>
              <ButtonUI
                type="callf"
                onClickFunc={() => modalHandler(true, 'pagar_factura', factura)}
                fullWidth
                label="PAGAR"
              />
            </ListItemSecondaryAction>
          </ToggleUI>
        </ListItem>
      );
    });
  } else {
    return (
      <ListItem>
        <ListItemText primary="No hay vencimientos disponibles para abonar, te avisaremos por email 10 días antes de tu primer vencimiento." />
      </ListItem>
    );
  }
};

const FacturasList_ = (props) => {
  let { facturas, pago_manual, modalHandler, classes, idCountry } = props;

  return (
    <List classes={{ root: classes.list }}>
      {renderizarFacturas(
        facturas,
        pago_manual,
        modalHandler,
        classes,
        idCountry
      )}
    </List>
  );
};

const styles = (theme) => ({
  span: {
    display: 'block',
    width: '90%',
    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
  },
  span_aux: {
    display: 'block',
    width: '90%',
    textDecoration: 'underline',
    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
  },
  list: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '0',
    '&:last-child': {
      borderBottom: '0px solid transparent',
    },
  },
  list_text: {
    paddingRight: '100px',
  },
  link: {
    color: 'inherit',
    cursor: 'pointer',
  },
});

export const FacturasList = withStyles(styles, { withTheme: true })(
  FacturasList_
);
